export const roundToDecimal = (numberToRound: number | string, decimal: number): number => {
  return typeof numberToRound === 'number'
    ? parseFloat(numberToRound.toFixed(decimal))
    : parseFloat(parseFloat(numberToRound).toFixed(decimal));
};
